var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStadium100(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1375_387)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 99,
    height: 99,
    rx: 15,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.625 36.7038C34.325 36.8489 34.0438 36.8398 33.7812 36.6765C33.5187 36.5132 33.3875 36.2864 33.3875 35.9961V30.77C33.3875 30.4796 33.5187 30.2528 33.7812 30.0895C34.0438 29.9262 34.325 29.9171 34.625 30.0623L39.9688 32.6753C40.1563 32.7479 40.2781 32.8477 40.3344 32.9747C40.3906 33.1017 40.4188 33.2378 40.4188 33.383C40.4188 33.5282 40.3906 33.6643 40.3344 33.7913C40.2781 33.9183 40.1563 34.0181 39.9688 34.0907L34.625 36.7038ZM65 36.7038C64.7 36.8489 64.4188 36.8398 64.1562 36.6765C63.8937 36.5132 63.7625 36.2864 63.7625 35.9961V30.77C63.7625 30.4796 63.8937 30.2528 64.1562 30.0895C64.4188 29.9262 64.7 29.9171 65 30.0623L70.3438 32.6753C70.5313 32.7479 70.6531 32.8477 70.7094 32.9747C70.7656 33.1017 70.7938 33.2378 70.7938 33.383C70.7938 33.5282 70.7656 33.6643 70.7094 33.7913C70.6531 33.9183 70.5313 34.0181 70.3438 34.0907L65 36.7038ZM50.825 34.744C50.525 34.8891 50.2437 34.8801 49.9812 34.7167C49.7187 34.5534 49.5875 34.3266 49.5875 34.0363V28.8102C49.5875 28.5198 49.7187 28.293 49.9812 28.1297C50.2437 27.9664 50.525 27.9573 50.825 28.1025L56.1687 30.7155C56.3562 30.7881 56.4781 30.8879 56.5344 31.0149C56.5906 31.142 56.6188 31.2781 56.6188 31.4232C56.6188 31.5684 56.5906 31.7045 56.5344 31.8315C56.4781 31.9585 56.3562 32.0583 56.1687 32.1309L50.825 34.744ZM48.6875 71C45.8375 70.8911 43.2125 70.6461 40.8125 70.2651C38.4125 69.884 36.3406 69.4031 34.5969 68.8225C32.8531 68.2418 31.4844 67.5794 30.4906 66.8355C29.4969 66.0915 29 65.3021 29 64.4674V44.8695C29 43.9622 29.5906 43.1184 30.7719 42.3381C31.9531 41.5579 33.5562 40.8683 35.5812 40.2695C37.6062 39.6707 39.9875 39.1989 42.725 38.8541C45.4625 38.5093 48.3875 38.3369 51.5 38.3369C54.6125 38.3369 57.5375 38.5093 60.275 38.8541C63.0125 39.1989 65.3938 39.6707 67.4188 40.2695C69.4438 40.8683 71.0469 41.5579 72.2281 42.3381C73.4094 43.1184 74 43.9622 74 44.8695V64.4674C74 65.3021 73.5031 66.0915 72.5094 66.8355C71.5156 67.5794 70.1469 68.2418 68.4031 68.8225C66.6594 69.4031 64.5875 69.884 62.1875 70.2651C59.7875 70.6461 57.1625 70.8911 54.3125 71V61.7455H48.6875V71ZM51.5 48.1358C55.1375 48.1358 58.3719 47.8727 61.2031 47.3465C64.0344 46.8202 66.8 46.0309 69.5 44.9784C68.6375 44.1074 66.6219 43.3271 63.4531 42.6375C60.2844 41.948 56.3 41.6032 51.5 41.6032C46.7 41.6032 42.7156 41.948 39.5469 42.6375C36.3781 43.3271 34.3625 44.1074 33.5 44.9784C36.2 46.0309 38.9656 46.8202 41.7969 47.3465C44.6281 47.8727 47.8625 48.1358 51.5 48.1358ZM45.3125 67.4615V61.7455C45.3125 60.8381 45.6406 60.0669 46.2969 59.4318C46.9531 58.7967 47.75 58.4791 48.6875 58.4791H54.3125C55.25 58.4791 56.0469 58.7967 56.7031 59.4318C57.3594 60.0669 57.6875 60.8381 57.6875 61.7455V67.4615C60.6875 67.28 63.2844 66.8899 65.4781 66.2911C67.6719 65.6922 69.3875 64.9936 70.625 64.1952V48.027C68.4875 48.9706 65.6938 49.769 62.2438 50.4223C58.7938 51.0755 55.2125 51.4021 51.5 51.4021C47.7875 51.4021 44.2062 51.0755 40.7562 50.4223C37.3062 49.769 34.5125 48.9706 32.375 48.027V64.1952C33.6125 64.9936 35.3281 65.6922 37.5219 66.2911C39.7156 66.8899 42.3125 67.28 45.3125 67.4615Z",
    fill: "#044535"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1375_387",
    x: 0,
    y: 0,
    width: 103,
    height: 103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0 0.117647 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1375_387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1375_387",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadium100);
export default __webpack_public_path__ + "static/media/stadium100.63f85b8c90685a40c7b9b90f5564ed03.svg";
export { ForwardRef as ReactComponent };